// NOTE: You need to restart webpack after editing this file.
//   (For tokens_postcss_plugin.ts to pick up the changes)
//
export const COLOR_TOKENS = {
  colorBlack: '#161616',
  colorBlackO15: '#16161626',
  // for usage when transparency isn't supported
  colorBlackO15OnWhite: '#dcdcdc',
  colorBlackO10: '#1616161a',
  colorBlackO05: '#1616160d',
  colorWhite: '#ffffff',
  colorWhiteO15: '#ffffff26',

  colorDarkGrey: '#222222',
  colorGrey: '#686868',
  colorLightGrey1: '#d8d5d1',
  colorLightGrey2: '#e4e2df',
  colorLightGrey3: '#f1f0ee',
  colorHoverTint: 'rgba(36, 26, 11)',

  colorPurple: '#6248ff',
  colorPurpleO25: '#6248ff26',
  colorLightPurple: '#9483ff',
  // these names are stupid:
  colorVeryLightPurple: '#e0daff',
  colorLighterPurple: '#efedff',
  colorPurpleDark: '#5339ee',

  colorOrange: '#ff7448',
  colorOrangeO10: '#ff74481a',

  colorRed: '#ff4848',
  colorRedO15: '#ff484826',

  colorBrandGradientStops: '#ff7448, #ff4848 51%, #6248ff 88%',

  colorGreenO10: '#16b3641a',
  colorGreen: '#16b364',
  colorGreenDark: '#129151',

  colorMidnightBlue: '#1d222c',
};
export type ColorToken = keyof typeof COLOR_TOKENS;

export const SHADOW_TOKENS = {
  shadowXXSmall: '0px 1px 2px 0px #0000000D',
  shadowXSmall: '0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A',
  shadowSmall: '0px 4px 8px -2px #0000001A, 0px 2px 4px -2px #0000000F',
  shadowMedium: '0px 4px 6px -2px #00000008, 0px 12px 16px -4px #00000014',
  shadowLarge: '0px 8px 8px -4px #00000008, 0px 20px 24px -4px #00000014',
  shadowXLarge: '0px 24px 48px -12px #0000002E',
  shadowXXLarge: '0px 32px 64px -12px #00000024',
};

const BREAKPOINT_TOKENS = {
  breakpointTablet: '767px',
  breakpointMobile: '479px',
};

const RADIUS_TOKENS = {
  radiusPanel: '12px',
  radiusCard: '8px',
};

export const TRANSITION_TOKENS = {
  transitionStandard: '0.2s ease-out',
};

export const ALL_TOKENS = {
  ...COLOR_TOKENS,
  ...SHADOW_TOKENS,
  ...BREAKPOINT_TOKENS,
  ...RADIUS_TOKENS,
  ...TRANSITION_TOKENS,
};
